import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AssetIconComponent } from './asset-icon.component';

@NgModule({
  imports: [
  CommonModule,
  ],
  declarations: [
  AssetIconComponent,
  ],
  exports: [AssetIconComponent,
  ],
  })
export class AssetIconModule { }
